// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonScreen-module_wrapper__z9VGs {
    bottom: 0;
    left: 0;
    min-width: 288px;
    overflow: auto;
    position: fixed;
    right: 0;
    top: 0;
}

.commonScreen-module_wrapper__z9VGs.commonScreen-module_background__zB5NB {
    background-color: var(--white);
}

.commonScreen-module_container__Ac_k7 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    padding: 72px 24px 92px 24px;
}

.commonScreen-module_centerContainer__FuVuu {
    width: 100%;
    max-width: 504px;
}

.commonScreen-module_buttonCenterContainer__UrCu4 {
    width: 100%;
    max-width: 504px;
    margin: 0 auto 92px;
}

.commonScreen-module_headerText__QJss2 {
    font: var(--typography-header);
    margin-top: 24px;

    @media screen and (min-width: 1920px) {
        font-size: 32px;
        line-height: 48px;
    }
}

.commonScreen-module_headerText__QJss2 span,
.commonScreen-module_headerText__QJss2 .commonScreen-module_color-GT__YlHNb {
    color: var(--purple_100);
}

.commonScreen-module_secondaryText__bhAnw {
    font: var(--typography-main);
    margin-top: 16px;
    color: var(--grey_72_lc);

    @media screen and (min-width: 1920px) {
        font-size: 20px;
        line-height: 32px;
    }
}

.commonScreen-module_mainText___oh6B {
    display: inline-block;
    font: var(--typography-main);
    margin-top: 24px;

    @media screen and (min-width: 1920px) {
        font-size: 20px;
        line-height: 32px;
    }
}

.commonScreen-module_mainText___oh6B.commonScreen-module_hasBorder__f5uxR {
    border-bottom: 1px solid var(--grey_16_lc);
    padding-bottom: 32px;

    @media screen and (min-width: 1920px) {
        padding-bottom: 48px
    }
}

.commonScreen-module_mainText___oh6B.commonScreen-module_breakWord__h1lVf {
    word-break: break-word;
}

/* The band the bar travels in. Below the tablet breakpoint it stays bare, so the bar runs over whatever sits
   behind it, as it did before the desktop rendition was added. */
.commonScreen-module_loaderTrack__NmBVu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    z-index: var(--zindex-loader-layout);
}

.commonScreen-module_loaderBar__rGTlg {
    width: 100%;
    height: 100%;
    background-color: var(--animationsColor, rgba(156, 108, 255, 1));
    animation: commonScreen-module_loader-animation__PzEsQ 800ms linear infinite;
}

/* Figma "Loader-desktop" (59977:37760): on a wide viewport the bar runs over a visible track and sweeps the
   screen once per cycle instead of bouncing. 708px is the package's own mobile/desktop switch, shared with
   bottomSheet.module.css and popupComponent.module.css. */
@media screen and (min-width: 708px) {
    .commonScreen-module_loaderTrack__NmBVu {
        background-color: var(--grey_8_lc);
    }

    .commonScreen-module_loaderBar__rGTlg {
        /* Both edges are driven off the left of the band: translateX places the trailing edge, scaleX stretches
           the bar rightwards from it. The sweep covers a whole desktop viewport, so it is paced slower than the
           bounce it replaces rather than reusing its 800ms. */
        transform-origin: left;
        animation-name: commonScreen-module_loader-animation-desktop__aZnWy;
        animation-duration: 2s;
    }
}

@keyframes commonScreen-module_loader-animation__PzEsQ {
    0% {
        transform: scaleX(0);
        transform-origin: left;
    }
    49.9% {
        transform: scaleX(1);
        transform-origin: left;
    }
    50% {
        transform: scaleX(1);
        transform-origin: right;
    }
    100% {
        transform: scaleX(0);
        transform-origin: right;
    }
}

/*
 * A hairline that grows out of the left edge, outruns itself, and is swallowed by the right one.
 *
 * translateX is the trailing edge, translateX + 100 * scaleX the leading one. Keeping translateX linear across
 * both keyframe spans is what holds the trailing edge at one constant speed for the whole cycle — it covers 60%
 * of the band in the first 60% of the time and the remaining 40% in the last 40%. The leading edge is the fast
 * one: it clears the whole band by the 60% mark (60 + 100 * 0.4 = 100), then stays pinned at the right edge
 * (100 + 100 * 0 = 100) while the trailing edge closes the gap.
 *
 * Starting at scaleX(0) matches the design, where the bar is 1px of the 1440px frame at rest.
 */
@keyframes commonScreen-module_loader-animation-desktop__aZnWy {
    0% {
        transform: translateX(0) scaleX(0);
    }
    60% {
        transform: translateX(60%) scaleX(0.4);
    }
    100% {
        transform: translateX(100%) scaleX(0);
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/common/CommonScreen/commonScreen.module.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,OAAO;IACP,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;;IAEhB;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,wBAAwB;;IAExB;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;;IAEhB;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,oBAAoB;;IAEpB;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;iEACiE;AACjE;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gEAAgE;IAChE,4EAAiD;AACrD;;AAEA;;0DAE0D;AAC1D;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI;;8DAEsD;QACtD,sBAAsB;QACtB,mEAAwC;QACxC,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,oBAAoB;QACpB,uBAAuB;IAC3B;IACA;QACI,oBAAoB;QACpB,uBAAuB;IAC3B;AACJ;;AAEA;;;;;;;;;;EAUE;AACF;IACI;QACI,kCAAkC;IACtC;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".wrapper {\n    bottom: 0;\n    left: 0;\n    min-width: 288px;\n    overflow: auto;\n    position: fixed;\n    right: 0;\n    top: 0;\n}\n\n.wrapper.background {\n    background-color: var(--white);\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    flex: 1;\n    padding: 72px 24px 92px 24px;\n}\n\n.centerContainer {\n    width: 100%;\n    max-width: 504px;\n}\n\n.buttonCenterContainer {\n    width: 100%;\n    max-width: 504px;\n    margin: 0 auto 92px;\n}\n\n.headerText {\n    font: var(--typography-header);\n    margin-top: 24px;\n\n    @media screen and (min-width: 1920px) {\n        font-size: 32px;\n        line-height: 48px;\n    }\n}\n\n.headerText span,\n.headerText .color-GT {\n    color: var(--purple_100);\n}\n\n.secondaryText {\n    font: var(--typography-main);\n    margin-top: 16px;\n    color: var(--grey_72_lc);\n\n    @media screen and (min-width: 1920px) {\n        font-size: 20px;\n        line-height: 32px;\n    }\n}\n\n.mainText {\n    display: inline-block;\n    font: var(--typography-main);\n    margin-top: 24px;\n\n    @media screen and (min-width: 1920px) {\n        font-size: 20px;\n        line-height: 32px;\n    }\n}\n\n.mainText.hasBorder {\n    border-bottom: 1px solid var(--grey_16_lc);\n    padding-bottom: 32px;\n\n    @media screen and (min-width: 1920px) {\n        padding-bottom: 48px\n    }\n}\n\n.mainText.breakWord {\n    word-break: break-word;\n}\n\n/* The band the bar travels in. Below the tablet breakpoint it stays bare, so the bar runs over whatever sits\n   behind it, as it did before the desktop rendition was added. */\n.loaderTrack {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    z-index: var(--zindex-loader-layout);\n}\n\n.loaderBar {\n    width: 100%;\n    height: 100%;\n    background-color: var(--animationsColor, rgba(156, 108, 255, 1));\n    animation: loader-animation 800ms linear infinite;\n}\n\n/* Figma \"Loader-desktop\" (59977:37760): on a wide viewport the bar runs over a visible track and sweeps the\n   screen once per cycle instead of bouncing. 708px is the package's own mobile/desktop switch, shared with\n   bottomSheet.module.css and popupComponent.module.css. */\n@media screen and (min-width: 708px) {\n    .loaderTrack {\n        background-color: var(--grey_8_lc);\n    }\n\n    .loaderBar {\n        /* Both edges are driven off the left of the band: translateX places the trailing edge, scaleX stretches\n           the bar rightwards from it. The sweep covers a whole desktop viewport, so it is paced slower than the\n           bounce it replaces rather than reusing its 800ms. */\n        transform-origin: left;\n        animation-name: loader-animation-desktop;\n        animation-duration: 2s;\n    }\n}\n\n@keyframes loader-animation {\n    0% {\n        transform: scaleX(0);\n        transform-origin: left;\n    }\n    49.9% {\n        transform: scaleX(1);\n        transform-origin: left;\n    }\n    50% {\n        transform: scaleX(1);\n        transform-origin: right;\n    }\n    100% {\n        transform: scaleX(0);\n        transform-origin: right;\n    }\n}\n\n/*\n * A hairline that grows out of the left edge, outruns itself, and is swallowed by the right one.\n *\n * translateX is the trailing edge, translateX + 100 * scaleX the leading one. Keeping translateX linear across\n * both keyframe spans is what holds the trailing edge at one constant speed for the whole cycle — it covers 60%\n * of the band in the first 60% of the time and the remaining 40% in the last 40%. The leading edge is the fast\n * one: it clears the whole band by the 60% mark (60 + 100 * 0.4 = 100), then stays pinned at the right edge\n * (100 + 100 * 0 = 100) while the trailing edge closes the gap.\n *\n * Starting at scaleX(0) matches the design, where the bar is 1px of the 1440px frame at rest.\n */\n@keyframes loader-animation-desktop {\n    0% {\n        transform: translateX(0) scaleX(0);\n    }\n    60% {\n        transform: translateX(60%) scaleX(0.4);\n    }\n    100% {\n        transform: translateX(100%) scaleX(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `commonScreen-module_wrapper__z9VGs`,
	"background": `commonScreen-module_background__zB5NB`,
	"container": `commonScreen-module_container__Ac_k7`,
	"centerContainer": `commonScreen-module_centerContainer__FuVuu`,
	"buttonCenterContainer": `commonScreen-module_buttonCenterContainer__UrCu4`,
	"headerText": `commonScreen-module_headerText__QJss2`,
	"color-GT": `commonScreen-module_color-GT__YlHNb`,
	"secondaryText": `commonScreen-module_secondaryText__bhAnw`,
	"mainText": `commonScreen-module_mainText___oh6B`,
	"hasBorder": `commonScreen-module_hasBorder__f5uxR`,
	"breakWord": `commonScreen-module_breakWord__h1lVf`,
	"loaderTrack": `commonScreen-module_loaderTrack__NmBVu`,
	"loaderBar": `commonScreen-module_loaderBar__rGTlg`,
	"loader-animation": `commonScreen-module_loader-animation__PzEsQ`,
	"loader-animation-desktop": `commonScreen-module_loader-animation-desktop__aZnWy`
};
export default ___CSS_LOADER_EXPORT___;
